<template>
    <div class="examCheckBox" :class="{'selected':isSelected || look }" >
        <el-checkbox-group v-model="checkList" @change="handleCheckedQes" :disabled='isSelected || look'>
            <el-checkbox :class='[letter(index),answerRightError(index,list.answer)]' :label="index+1" v-for='(item,index) in list.userOptions' :key='index'>{{ item }}</el-checkbox>
        </el-checkbox-group>
        
        <template v-if='!look'>
            <el-button class="btn" type="primary" @click="over" v-if='!isSelected'>完  成</el-button>
        </template>
         <div class="answerBox" v-show='isSelected || look'>
            <p>正确答案：{{ optionsLetter(list.answer) }}</p>
            <p>我的答案：{{ optionsLetter(selected[this.list.qid]) }}</p>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        list:{
            type:Object
        },
        selected: {
            type: Object
        },
        look: {
            type: Boolean
        },
    },
    data () {
        return {
            checkList: [],
            isSelected:false,//判断此道题是否选完
        }
    },
    computed:{
        /**
         * 转化字母 添加class
         */
        letter () {
            return function (param) {
                return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'][param];
            }
        },
        /**
         * 转化字母
         */
        optionsLetter () {
            return function (param) {
                if( !param )return;
                
                let arr = param.split(',');

                let letterArr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

                let letter = '';
                for( let i in arr ){
                    letter += letterArr[arr[i]-1]+'、';
                }
                return letter.slice(0,letter.length-1);
            }
        },
        /**
         * 判断选项是正确还是错误  添加class
         */
        answerRightError () {
            return function (idx, answer) {
                idx = idx + 1;
                if ( answer.indexOf(idx) != -1 ) {
                    return 'ok';
                }

                if( this.selected[this.list.qid] ){
                    if ( this.selected[this.list.qid].indexOf(idx) != -1 ) {
                        return 'error'
                    } 
                }

                return '';
            }
        },
    },
    watch: {
        selected () {
            if (this.selected[this.list.qid]) {

                this.isSelected = true;
            } else {
                this.isSelected = false;
            }
        }
    },
    mounted(){
       
    },
    methods : {
        /**
         * 多选框选择
         */
        handleCheckedQes(){
            // console.log(this.checkList.join(','))
            // let obj = {};
            // obj[this.list.qid] = this.checkList.sort().join(',');//+1 从1开始
            // this.$emit('changeQes', obj)
        },
        /**
         * 结束
         */
        over(){
            console.log(this.checkList);
            if( !this.checkList.length ){
                this.$message({
                    type:'error',
                    message:'请选择多选题选项'
                });
                return false;
            }
            // this.list.
            let obj = {};
            obj[this.list.qid] = this.checkList.sort().join(',');//+1 从1开始
            this.$emit('changeQes', obj)
        }
    }
}
</script>
<style lang="stylus" scoped>
.el-checkbox-group
    .el-checkbox
        display block
        margin-bottom 18px
.btn
    width 290px
    background-image $btnBg
    background-size 100% 100%
</style>
<style lang="stylus">

.examCheckBox 
    .el-checkbox
        .el-checkbox__input.is-checked
            .el-checkbox__inner
                background-image url('~@/assets/images/circle_active.png')
                &::after
                    color:#fff
        .el-checkbox__inner
            width 28px
            height 28px
            line-height 24px
            text-align center
            border 0
            background-image url('~@/assets/images/circle.png')
            background-size 100% 100%!important
            transform rotate(0)
            background-color transparent!important
            &::after
                width 28px
                height 28px
                left 0
                transform rotate(0) !important
    .el-checkbox.A 
        .el-checkbox__inner::after
            content 'A'
    .el-checkbox.B
        .el-checkbox__inner::after
            content 'B'
    .el-checkbox.C
        .el-checkbox__inner::after
            content 'C'
    .el-checkbox.D
        .el-checkbox__inner::after
            content 'D'
    .el-checkbox.E
        .el-checkbox__inner::after
            content 'E'
    .el-checkbox.F
        .el-checkbox__inner::after
            content 'F'
    .el-checkbox.G
        .el-checkbox__inner::after
            content 'G'
    .el-checkbox.H
        .el-checkbox__inner::after
            content 'H'
.examCheckBox.selected
    .el-checkbox-group
        .ok
            .el-checkbox__inner
                background-image url('~@/assets/images/ok.png')
            .el-checkbox__inner::after
                content ''
            .el-checkbox__label
                color #208FF8
        .error
            .el-checkbox__inner
                background-image url('~@/assets/images/error.png')
            .el-checkbox__inner::after
                content ''
            .el-checkbox__label
                color #F93D3D

</style>


// WEBPACK FOOTER //
// src/components/my/exam/checkbox.vue